import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionInterceptor } from './session.interceptor';
import { CheckConnectionInterceptor } from './check-connection-interceptor.service';

export const HTTP_INTERCEPTOR_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CheckConnectionInterceptor, multi: true }
];
